import React from "react";
import { FlexContainer } from "src/components";
import FormField from "src/components/FormField";
import { TextLabel } from "../../style";

export const ArticleWebLinkField = ({ value, onChange }) => {
    return (
        <FlexContainer>
            <TextLabel color="#000000" fontSize="16px" fontWeight="bold"
            > Web Link (Optional)</TextLabel>
            
            <FormField borderRadius="10px" size="14px" height="50px"
                placeholderColor="#808080" border="1px solid #D8DEEC"
                backgroundColor={"#FFFFFF 0% 0% no-repeat padding-box"}
                boxShadow="0px 3px 6px #00000029"
                opacity="1"
                align="left"
                width="100%"
                type="text"
                placeholder={"Enter a URL to add to your article"}
                onChange={(e) => onChange(e.target.value) }
                maxLength="100"
                value={value}
                readOnly={false}
                style={{ boxShadow: "0px 3px 6px #00000029" }}
            />
        </FlexContainer>
    );
};
